import {Component, Output, EventEmitter} from '@angular/core';
import {DataLayerService} from './data-layer.service';

// LegendComponent class provides a legend dialog whose only function is to display
// current map layers range of values
// Cat - look at http://leafletjs.com/reference.html#icontrol search Draggable
@Component({
	selector: 'legend-dialog',
	templateUrl: 'legend.component.html',
	styleUrls: ['legend.component.css']
})

export class LegendComponent {

	dataLayerService: DataLayerService;
	novaScoreDescription: any[] = [];
	fitNovaScoreDescription: any[] = [];

	constructor(dataLayerService: DataLayerService) {
		this.dataLayerService = dataLayerService;

		// dataLayerService has an observable legendList$ to listen to
		// The content sent from legendList$ is in the form of a group:
		// 	{ "id": novaScoreLevel, "description": novaScoreDescription }
		this.dataLayerService.legendList$.subscribe( message => {
			const units = (message.units == null || message.units.length === 0) ? '' : ( ' (' + message.units + ')');
			if ( message.dataType === 'dataDisplayLayer' ) {
				this.novaScoreDescription[message.id] = message.description + units;
			} else if ( message.dataType === 'fit' ) {
				this.fitNovaScoreDescription[message.id] = message.description + units;
								}
		});

	}

}


